<template>
  <div class="card p-6 pt-7">
    <button class="delete" @click="cancel"></button>
    <div class="is-flex is-flex-direction-column">
      <p class="has-text-weight-bold is-size-3 mb-5">
        {{ $t("mp:new_application.modal.cancel.title") }}
      </p>
      <p class="mb-5">
        {{ $t("mp:new_application.modal.cancel.message") }}
      </p>
    </div>
    <div class="is-flex is-flex-direction-row is-justify-content-flex-end">
      <b-button @click="cancel" class="mr-4"
        >{{ $t("mp:new_application.button.cancel") }}
      </b-button>
      <b-button @click="discard" type="is-danger"
        >{{ $t("mp:new_application.button.abort") }}
      </b-button>
    </div>
  </div>
</template>
<script>
export default {
  name: "BnplApplicationCancel",
  methods: {
    cancel() {
      this.$parent.close();
    },
    discard() {
      this.$router.push({
        name: "BnplApplications",
      });
      this.$store.dispatch("bnplInStoreApplication/clear");
      this.$parent.close();
    },
  },
};
</script>
<style lang="scss">
.card {
  // position: relative;
  border-radius: 24px;

  button.delete {
    position: absolute;
    top: 16px;
    right: 16px;
  }

  input.input {
    cursor: text !important;
  }

  .control.has-icons-right .icon {
    color: #051c3a;
  }
}
</style>
